// extracted by css-extract-rspack-plugin
export default {"listbox":"lHSZm","item":"vD6B3","icon":"EyrrC","label":"xROao","highlight":"vZLJf","footer":"GTAsD","key":"skOzd"};